(function() {
  try {
    var f = document.createElement("iframe");
    f.src = 'https://forms.zohopublic.com/keralastartupmission/form/XROpportunities/formperma/sdWkPD9kh6tMeIapWTRDIagd6lUrP-6VApbN9_bNRWo?zf_rszfm=1';
    f.style.border = "none";
    f.style.height = "1711px";
    f.style.width = "90%";
    f.style.transition = "all 0.5s ease"; // No I18N
    var d = document.getElementById("zf_div_sdWkPD9kh6tMeIapWTRDIagd6lUrP-6VApbN9_bNRWo");
    d.appendChild(f);
    window.addEventListener('message', function() {
      var zf_ifrm_data = event.data.split("|");
      var zf_perma = zf_ifrm_data[0];
      var zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 70) + "px";
      var iframe = document.getElementById("zf_div_sdWkPD9kh6tMeIapWTRDIagd6lUrP-6VApbN9_bNRWo").getElementsByTagName("iframe")[0];
      if ((iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
        var prevIframeHeight = iframe.style.height;
        if (prevIframeHeight != zf_ifrm_ht_nw) {
          iframe.style.height = zf_ifrm_ht_nw;
        }
      }
    }, false);
  } catch (e) {}
})();